import { ProductTypes } from '../../enums/product-types';
import { convertDimensions } from '../../services/unit-services/dimensions/dimension-convert-service';
import { convertFromDimensionUnitEnum } from '../../services/unit-services/dimensions/dimension-unit-enum-converter';
import { convertWeight } from '../../services/unit-services/weights/weight-convert-service';
import { convertFromWeightUnitEnum } from '../../services/unit-services/weights/weight-unit-enum-converter';

export const getProductTypeDisplayNameAndHeaderText = (productType) => {
  const enumObj = ProductTypes[productType] || ProductTypes.Standalone;

  return {
    headerText: enumObj.productDetailHeaderText,
    productTypeText: enumObj.displayText,
  };
};

export const convertWeightToDisplayUnit = (sellerWeightUnitSetting, weight, weightUnit) => {
  if (weight == null) {
    return {
      weight: undefined,
      weightUnit: convertFromWeightUnitEnum(sellerWeightUnitSetting),
    };
  }

  const { value, unit } = convertWeight({ value: weight, unit: weightUnit }, sellerWeightUnitSetting);
  const formattedValue = Number.isInteger(value) ? value : Number.parseFloat(value.toFixed(3));

  return {
    weight: formattedValue,
    weightUnit: convertFromWeightUnitEnum(unit),
  };
};

export const convertDimensionToDisplayUnit = (sellerDimensionUnitSetting, dimensionsWithUnit) => {
  const { length, width, height, unit } = convertDimensions(dimensionsWithUnit, sellerDimensionUnitSetting);

  return {
    convertedLength: length,
    convertedWidth: width,
    convertedHeight: height,
    sizeUnit: convertFromDimensionUnitEnum(unit),
  };
};

export const locationNameFromParts = (location) => {
  const { area, unit, shelf, bin } = location;
  const parts = [area, unit, shelf, bin].filter((part) => part && part.length > 0);
  return parts.join(' - ');
};
